/**
 * Simple utility to merge CSS classes
 * Filters out falsy values and joins remaining classes with spaces
 * 
 * @param {...(string|null|undefined|false)} classes - Class names to merge
 * @returns {string} Merged class string
 * 
 * @example
 * cn('base-class', isActive && 'active', 'another-class')
 * // Returns: "base-class active another-class" (if isActive is true)
 * 
 * cn('base-class', false, null, undefined, 'valid-class')
 * // Returns: "base-class valid-class"
 */
export function cn(...classes) {
    return classes.filter(Boolean).join(' ');
}
